import { useTournamentStore } from '@/stores/tournaments';
import { useAnonymousScoreExists } from '@/composables/api/actions/handles';

export default function usePlayHandleAnonymously() {
  const tournamentStore = useTournamentStore();
  const { anonymouslyPlayedHandleId } = storeToRefs(useTournamentStore());

  const loading = ref(false);

  async function playHandleAnonymously() {
    if (!loading.value) {
      loading.value = true;

      await tournamentStore.playHandleAnonymously();

      loading.value = false;
    }
  }

  async function getIsHandleAnonymouslyPlayed(): Promise<boolean> {
    if (anonymouslyPlayedHandleId.value) {
      const { data } = await useAnonymousScoreExists(
        anonymouslyPlayedHandleId.value
      );
      if (data) {
        return data.exists;
      }
    }

    return false;
  }

  return {
    loading,
    playHandleAnonymously,
    getIsHandleAnonymouslyPlayed
  };
}
